import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { name: '首页', path: '/' },
  { name: '网红爆料', path: '/category/wanghong-baoliao' },
  { name: '娱乐圈', path: '/category/yule-quan' },
  { name: '直播圈', path: '/category/zhibo-quan' },
  { name: '主播八卦', path: '/category/zhubo-bagua' },
  { name: '关于我们', path: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 flex-shrink-0">
            <div className="w-8 h-8 bg-accent-500 rounded-lg flex items-center justify-center">
              <i className="ri-fire-fill text-background-50 text-lg"></i>
            </div>
            <span className="text-xl font-bold font-heading text-foreground-950">
              黑料在线
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-colors whitespace-nowrap ${
                  location.pathname === link.path
                    ? 'text-accent-600'
                    : scrolled || !isHome
                      ? 'text-foreground-700 hover:text-foreground-950'
                      : 'text-foreground-50 hover:text-background-100'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button className="whitespace-nowrap px-5 py-2 bg-accent-500 text-background-50 rounded-full text-sm font-medium hover:bg-accent-600 transition-colors cursor-pointer">
              我要爆料
              <i className="ri-arrow-right-line ml-1"></i>
            </button>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${scrolled || !isHome ? 'text-foreground-900' : 'text-background-50'} ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setMobileOpen(false)}
                className={`text-sm font-medium py-2 transition-colors ${
                  location.pathname === link.path
                    ? 'text-accent-600'
                    : 'text-foreground-700 hover:text-foreground-950'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <button className="whitespace-nowrap px-5 py-2 bg-accent-500 text-background-50 rounded-full text-sm font-medium hover:bg-accent-600 transition-colors cursor-pointer text-center mt-2">
              我要爆料
              <i className="ri-arrow-right-line ml-1"></i>
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}